import { createStore } from "vuex";

export default createStore({
  state: {
    questions: [
      {
        num: "one",
        bigTitle: "根据患者的临床表现，最初的诊断结果可能是?(多选)",
        radioList: [
          {
            name: "1",
            title: "A.湿疹",
          },
          {
            name: "2",
            title: "B.特应性皮炎",
          },
          {
            name: "3",
            title: "C.接触性皮炎",
          },
          {
            name: "4",
            title: "D.溢脂性皮炎",
          },
          {
            name: "5",
            title: "E.其他",
          },
        ],
      },
      {
        num: "two",
        bigTitle:
          "AD继发细菌感染且有明显感染征象时，以下哪个治疗方案较为合适？",
        radioList: [
          {
            name: "1",
            title: "A.渗出部位用抗炎制剂，并配合保湿剂治疗",
          },
          {
            name: "2",
            title: "B. 渗出部位仅用抗生素治疗",
          },
          {
            name: "3",
            title: "C.渗出部位抗炎制剂联合抗生素治疗",
          },
        ],
      },
      {
        num: "four",
        bigTitle:
          "AD是一种异质性疾病，表现多种多样，诊断需要一定标准，姚志荣等提出的中国儿童AD临床诊断标准,敏感率高，以下对该标准描述正确的为（）",
        radioList: [
          {
            name: "1",
            title: "A. 瘙痒",
          },
          {
            name: "2",
            title:
              "B.典型的形态和部位（屈侧皮炎）或不典型的形态和部位同时伴发干皮症",
          },
          {
            name: "3",
            title: "C.慢性或慢性复发性病程",
          },
          {
            name: "4",
            title: "D.同时具备以上3条即可诊断AD",
          },
          {
            name: "5",
            title: "E.符合A、B、C任意2条即可诊断AD",
          },
        ],
      },
      {
        num: "three",
        bigTitle: "通过该患儿的体格检查，以下描述正确的有()",
        radioList: [
          {
            name: "1",
            title: "A. 四肢伸侧、腰腹部红斑丘疹，水疱，大量渗出，可见黄痂",
          },
          {
            name: "2",
            title: "B. 局部可见抓痕",
          },
          {
            name: "3",
            title: "C. 躯干红斑，无明显丘疹、水疱",
          },
          {
            name: "4",
            title: "D. 以上均描述正确",
          },
        ],
      },
    ],
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
